import React from 'react';
import './Users.css'
import {UsersTable, Settings, Search, ModalInfo} from '../../organisms'
import { Selectdisign} from '../../molecules'
import { useSelector, useDispatch } from 'react-redux'; 
import SignUp from '../SignUp/SignUp'
import {getUsersPage, getUserID} from '../../../store/api.js'
import { ModalContainer, InputRadio } from '../../atoms' 
import { sortUser, subsUser } from '../../../constants/constants.js' 
import { useRef } from 'react'; 
import { deleteUsers} from '../../../store/api.js'


export function Users(props) {
  const {users, totalCount, statusUser} = useSelector(state => state.users)
  const { lib, statusLib } = useSelector(state => state.lib)  
  const { currentUser } = useSelector(state => state.currentUser)
  const { plans } = useSelector(state => state.plans)
  const dispatch= useDispatch()
  const limit = 10
  const sortRef =  useRef()
  const [sort, setSort] = React.useState(sortUser[0]) 
  const allPages = Math.ceil(totalCount/limit) // Все карточки разделенные на количество карточек на странице
  const pages = Array.from({length: allPages}, (_, i) => i + 1)
  const [currentPage, setCurrentPage] = React.useState(1) 
  const [isOpen, setIsOpen] = React.useState(false) 
   const [isOpenSort, setIsOpenSort] = React.useState(false) 
  const [user, setUser] = React.useState({})  
  const [keyword, setKeyword] = React.useState('')
  const [subs, setSubs] = React.useState('')
  const [showChoice, setShowChoice] = React.useState(false) // Показывает вопрос об удалении юзера
  const [accesAdmin, setAccessAdmin] = React.useState(false) 
  const [accesVisor, setAccessVisor] = React.useState(false)
  const options = [
    { value: 'free', label: 'Бесплатная' },
    { value: 'standart', label: 'Стандарт' },
    { value: 'family', label: 'Семейная' }, 
    { value: 'premium', label: 'Премиум' }, 
  ];
  console.log(showChoice)
  React.useEffect(()=> { 
    if(currentPage) { 
      dispatch(getUsersPage({currentPage, limit, sort: sort.nameEn, subs, sortOrder: sort.sortOrder, accesAdmin, accesVisor}))
    } 
  },[currentPage, sort, subs])

   

  function handleSearch() {
    dispatch(getUserID(keyword))
  }
 
  //Слушатель на ввод поисковых слов
function handleChangeInput(e) {
  setKeyword(e.target.value)
}

  //Счетчик изменения страниц
 function handleCounter(page) {
  setCurrentPage(page)
} 

function handlePopupModal() {
  setIsOpenSort(!isOpenSort)
}

function handleChangeEvents(el) {  
  setSort(el)
  setCurrentPage(1)
} 

function handleSettings(user) {
  setIsOpen(true)
  setUser(user)
}
function hanleClose () {
  setIsOpen(false)
  setShowChoice(false)
}

function handleSearchDish (e) {
  setKeyword(e.target.value);
}

function handleSort () { 
  setSort(!sort)
}


function handleChoiceType(e) {
  //const { name, checked } = e.target; 
  setSubs(e.target.value);
  setCurrentPage(1); 
}
const toggleInfo = () => {
  setShowChoice(false)
}

function handleDeleteModal (user) {
  console.log(user)
  setShowChoice(true)
  setUser(user)

  // dispatch(deleteUsers({id: user._id, current: currentUser.supervisor}))
 }
 
  function handleDeleteUser () {
    dispatch(deleteUsers({id: user._id, current: currentUser.supervisor}))
    setShowChoice(false) 
  }

  return (
    <main className='content'>  
    <p>Число пользователей: {totalCount} Общее количество планов: {plans.length}</p>
    <Search onSearch={handleSearchDish} keyword={keyword} text='по id' placeholder='Искать по id'/>
    <button className='my-recipe__add-button' onClick={handleSearch}>Найти</button>
    <div className='sort-user df-r g20'> 
      <fieldset className='user-filter'> 
        <InputRadio
          options={options}
          selectedValue={subs}
          onChange={handleChoiceType}
          name='subs'
        />
        </fieldset>
        <Selectdisign 
          data={sortUser} 
          name={sort}
          ref={sortRef}
          title='sort'
          isOpen={isOpenSort}
          handleChangeEvents={handleChangeEvents}
          handlePopupModal={handlePopupModal}
        />  
       
      </div>
    <div className='table'>
      <div className='table__thead'>
        <ul className='table__tr_recipe'>
          <li className='table__th'>Имя/Email</li> 
          <li className='table__th'>Подписка</li>
          <li className='table__th'>Доступ</li>
          <li className='table__th'>Даты </li>
          <li className='table__th'>Баланс/Бонусы</li>
          <li className='table__th'>Рецепты/Планы</li> 
          <li className='table__th'>Настройки</li>
         
        </ul>
      </div>
      <div className='table__user'>
      {statusUser === 'resolved' &&
        users.map((user)=> (
          <UsersTable 
            user={user} 
            nVisorUser={props.onVisorUser} 
            onAdminUser={props.onAdminUser} 
            onUpdateUser={props.onUpdateUser} 
            onAccesUser={props.onAccesUser}
            onDeleteUser={props.onDeleteUser} 
            key={user._id}
            onVisorUser={props.onVisorUser}
            onEditUserData={props.onEditUserData}
            onSubmit={props.onSubmit}
            handleSettings={handleSettings}
            handleDeleteModal={handleDeleteModal}
           />
       ))
     }
         
      </div>
    </div>

    {  isOpen && 
      <ModalContainer 
        isOpen={isOpen}
        onClose={hanleClose}
        title='settings'
      > 
       <Settings type='plans' user={user} /> 
      </ModalContainer>
    }
    <div className='pages-recipe'>
      {pages.map((page, index)=> 
        <span 
          className={`page__number ${currentPage === page ? 'page__current' : ''}`}
          key={index} 
          onClick={()=>handleCounter(page)}>{page}</span>
      )}
    </div> 
    {showChoice && 
        <ModalInfo  
          onClose={hanleClose}   
          name='choice-delete'
          textError={`Подтвердите удаление пользователя "${user.name}"`}
          icon={false}
          toggleModal={toggleInfo}
        >
       <div className="g10 flexRowCenter" > 
       <button onClick={handleDeleteUser} className="buttonGrey font20Norm " type="button" aria-label={props.buttonName}>Да</button>
       <button onClick={hanleClose} className="buttonGreen font20Norm " type="button" aria-label={props.buttonName}>Нет</button>
       </div>
     </ModalInfo>
      }
  </main>
  )
   
}